import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax
        .get("ProductManagement/api/WarrantiesQuery?Take=100&Skip=0")
        .then(r => {
          commit("setList", r.data);
        });
    },
    fetchMinify({ commit, dispatch }) {
      return ajax.get("ProductManagement/api/WarrantiesQuery/0").then(r => {
        commit("setList", r.data);
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("ProductManagement/api/Warranties", model).then(() => {
        dispatch("fetch");
      });
    },
    UpdateFromKhadamat({ commit, dispatch }) {
      return ajax
        .post("ProductManagement/api/KhadamatWarranties", {})
        .then(() => {
          dispatch("fetch");
        });
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "ProductManagement/api/Warranties",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          dispatch("fetch");
        });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("ProductManagement/api/Warranties", model).then(() => {
        dispatch("fetch");
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
